import accountService from "../services/account.service";

const accounts = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, account) {
            return accountService.create(account);
        },
        addNote(_, params) {
            return accountService.addNote(params.accountId, params.text);
        },
        addClinicalNote(_, params) {
            return accountService.addClinicalNote(params.accountId, params.text, params.treatmentDate);
        },

        //READ
        get(_, params) {
            return accountService.get(params.id, params.urlParameters, params.requestId);
        },
        getageing(_, params) {
            return accountService.getAgeing(params.urlParameters);
        },
        getageingmanagement(_, params) {
            return accountService.getageingmanagement(params.urlParameters);
        },
        getmanagementaccountswidgetdto(_, params) {
            return accountService.getmanagementaccountswidgetdto(params.urlParameters);
        },
        getStatuses() {
            return accountService.getStatuses();
        },
        getUserAllowedStatuses() {
            return accountService.getUserAllowedStatuses();
        },
        getFundingTypes() {
            return accountService.getFundingTypes();
        },

        //UPDATE
        update(_, account) {
            return accountService.update(account);
        },
        resetstatus(_, account) {
            return accountService.resetstatus(account);
        },
        grvimport(_, form) {
            return accountService.grvimport(form);
        },
        /*
        updateClaimDetails(_, params) {
            return accountService.updateClaimDetails(params.id, params.formData);
        },
*/
        //DELETE
        delete(_, id) {
            return accountService.delete(id);
        },

        //ACCOUNT FILES
        //CREATE
        createFile(_, params) {
            return accountService.createFile(params.accountId, params.formdata);
        },
        //READ
        getFileTypes() {
            return accountService.getFileTypes();
        },
        //UPDATE
        updateFile(_, entity) {
            return accountService.updateFile(entity);
        },
        //DELETE
        deleteFile(_, params) {
            return accountService.deleteFile(params.accountId, params.accountFileId);
        },
    },
    getters: {},
    mutations: {},
};

export default accounts;
